// extracted by mini-css-extract-plugin
export default {"category":"OtNN89huPQKdW8F3pwVK"};